import * as _ from "lodash";
import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";

interface DistributorEntityParams {
  id: number;
  name?: string;
}
export class DistributorEntity extends BaseEntityClass {
  id: number;
  name?: string;
  constructor(params: DistributorEntityParams) {
    super();
    this.type = "distributor";
    this.entity_version = 3;
    this.id = params.id;
    if (params.name) this.name = params.name;
  }

  static fromDistributor(distributor: any): DistributorEntity {
    distributor = _.pick(distributor, ["id", "name"]);

    return new DistributorEntity(distributor);
  }
}
